import React, { useEffect } from 'react';
import { Breadcrumb } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { RBHBox, RBHText } from '../../../../shared/components';
import { FormAddEdit } from '../components/FormAddEdit';
import { generalCreators } from '../../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { MODAL_TYPE } from '../../../../redux/general/general-constant';
import styleText from '../../../../shared/components/rbh-text/styles';
import styles from './styles';
import userStyles from '../styles';

export const AddUserScreen: React.FC<Props> = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {

  });

  const dispatchModal = (path: any) => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => history.push(path),
      type: MODAL_TYPE.CONFIRM_EDIT
    }));
  };

  const getBreadcrumb = () => {
    return (
      <Breadcrumb style={styleText.breadCrumb}>
        <Breadcrumb.Item>
          <a data-testid={'breakcrumb_user_tohomepage'} id={'breakcrumb_user_tohomepage'} style={styleText.breadCrumbItemLink} onClick={() => dispatchModal('/main')}>
            <FormattedMessage id={'main.main'} />
          </a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <a data-testid={'usermanagement'} style={styleText.breadCrumbItemLink} onClick={() => dispatchModal('/main/usermanagement')}>
            <FormattedMessage id={'main.user.usermanagement'} />
          </a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span style={styleText.breadCrumbItem}>
            <FormattedMessage id={'main.user.add'} />
          </span>
        </Breadcrumb.Item>
      </Breadcrumb>
    );
  };

  const getContent = () => {
    return (
      <div style={userStyles.defaultContent}>
        <RBHBox style={userStyles.header}>
          <RBHText text={'main.user.add'} style={styleText.headerText} />
        </RBHBox>
        <RBHBox style={styles.formWrapper}>
          <FormAddEdit onSuccessCallback={() => history.push('/main/usermanagement')} onCancel={dispatchModal}></FormAddEdit>
        </RBHBox>
      </div>
    );
  };

  return (
    <div>
      { getBreadcrumb()}
      { getContent()}
    </div>
  );
};

type Props = {

};
